module.exports = __webpack_public_path__ + "assets/img/BnBerry-Landing-Page-+-Website.1e653dea.jpg";